import React from "react";
import Layout from "../Layout";
import NoticeBoard from "../../../widgets/operator/lms/NoticeBoard";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";

function Lms() {
  const { data, loading, error } = useFetchWithAuth("/info/lms/");

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return <Layout>{<NoticeBoard data={data} />}</Layout>;
}

export default Lms;
